import {gql} from '@apollo/client';

export const GET_SCIENTIFIC_MODELS_QUERY = gql`
  query GetScientificModels @skipAudit @engComponent(name: MODEL_HUB) {
    scientificModels {
      displayName
      systemName
      iconPath
      category
      description
      paperLink
      inputTypes
    }
  }
`;
